import React from "react";

const STATS = [
  { value: "15+", label: "Projects" },
  { value: "3+", label: "Years Experience" },
  { value: "6", label: "Blog Articles" },
  { value: "12", label: "Open Source Contributions" },
];

const SKILL_GROUPS = [
  {
    icon: "💻",
    title: "Frontend",
    skills: ["React", "Next.js", "TypeScript", "Tailwind CSS", "Redux"],
  },
  {
    icon: "⚙️",
    title: "Backend",
    skills: ["Node.js", "Express", "Python", "Flask", "FastAPI"],
  },
  {
    icon: "🗄️",
    title: "Database",
    skills: ["PostgreSQL", "MongoDB", "Redis", "MySQL"],
  },
  {
    icon: "🛠️",
    title: "DevOps & Tools",
    skills: ["Docker", "Git", "AWS", "CI/CD", "Linux"],
  },
];

const About = () => {
  return (
    <div>
      {/* ─────────────── INTRO ─────────────── */}
      <section className="section">
        <div className="container">
          <h1 className="section-title">About Me</h1>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "3rem",
              marginBottom: "3.5rem",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <div
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "1rem",
                  backgroundColor: "var(--bg-card)",
                  border: "1px solid var(--border)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span style={{ fontSize: "3.5rem", fontWeight: 700, color: "var(--accent)" }}>
                  KSR
                </span>
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <p style={{ color: "var(--text-muted)", fontSize: "1.125rem", lineHeight: 1.8, marginBottom: "1.25rem" }}>
                I'm a passionate Full Stack Developer with 3+ years of experience building modern web
                applications. I specialize in creating efficient, scalable solutions using cutting-edge
                technologies.
              </p>
              <p style={{ color: "var(--text-muted)", fontSize: "1.125rem", lineHeight: 1.8 }}>
                From AI-driven blockchain systems to autonomous vehicle control interfaces, I love
                tackling complex challenges that push the boundaries of what's possible with web
                technology.
              </p>
            </div>
          </div>

          {/* ─────────────── STATS ─────────────── */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
              gap: "1.5rem",
            }}
          >
            {STATS.map((stat) => (
              <div key={stat.label} className="stat-card card" style={{ padding: "1.5rem", textAlign: "center" }}>
                <div style={{ fontSize: "1.875rem", fontWeight: 700, color: "var(--accent)", marginBottom: "0.5rem" }}>
                  {stat.value}
                </div>
                <div style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─────────────── SKILLS ─────────────── */}
      <section className="section" style={{ backgroundColor: "var(--bg-primary)" }}>
        <div className="container">
          <h2 className="section-title">Skills</h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "1.5rem",
            }}
          >
            {SKILL_GROUPS.map((group) => (
              <div key={group.title} className="skill-card card" style={{ padding: "1.5rem" }}>
                <div style={{ fontSize: "2.25rem", marginBottom: "1rem" }}>{group.icon}</div>
                <h3 style={{ color: "var(--text-primary)", fontWeight: 600, fontSize: "1.25rem", marginBottom: "1rem" }}>
                  {group.title}
                </h3>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                  {group.skills.map((skill) => (
                    <span key={skill} className="tag" style={{ borderRadius: "9999px" }}>
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
